import CreateReceivableForm from "../../components/XFlowPayment/FormSteps/CreateReceivable";
import PartnersList from "../../components/XFlowPayment/PartnersList";

export default function ReceivableAndPartners() {
  return (
    <section className="grid grid-cols-[600px_300px] gap-5">
      <CreateReceivableForm />

      <PartnersList />
    </section>
  );
}
